import React, { useContext, useEffect, useRef, useState } from "react";
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import { AddPendingContractConfig } from "./AddPendingContract.formfield.config";
import Buttons from "../../../../../../../components/ui/button/Buttons";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import { useLazyGetClientByPendingContractIdQuery, useLazyGetPendingContractDepartmentsQuery, useSavePendingContractScopesMutation } from "../../../../../../../app/services/pendingContractAPI";
import { mapDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { PendingContractContext } from "../../../../../../../utils/context/PendingContractContext";
import { useLazyCheckScopeSerialNumberExistsQuery, useLazyGetInstrumentTypesForContractQuery } from "../../../../../../../app/services/contractAPI";
import { useLazyGetInstrumentTypeListQuery, useLazyGetScopeTypeListQuery } from "../../../../../../../app/services/commonAPI";
import { setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";
import SwalAlert from "../../../../../../../services/swalService/SwalService";
import { useLazyGetScopeTypeDetailsByIdQuery } from "../../../../../../../app/services/scopeModelAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";
import { getSelectedDropdownObject } from "../../../../../../../components/finalForms/libs/data/dropdownUtilities";


const AddPendingContractScopes = ({ onClose, editRowData, getPendingContractScopes }) => {
  const SpecificationsRef = useRef();
  const { confirm } = SwalAlert();

  const { pendingContractId } = useContext(PendingContractContext) || {};

  const [addPendingContractConfigForm, setAddPendingContractConfigForm] = useState(AddPendingContractConfig);
  const [gridData, setGridData] = useState([{}]);
  const [isEdit, setIsEdit] = useState(false);

  const [getAllClientsByPendingContractId, {
    isFetching: isAllClientsByPendingContractIdFetching,
    isSuccess: isAllClientsByPendingContractIdFetched,
    data: allClientsByPendingContractIdData,
  },] = useLazyGetClientByPendingContractIdQuery();

  const [getPendingContractDepartments, {
    isFetching: isPendingContractDepartmentsFetching,
    isSuccess: isPendingContractDepartmentsFetched,
    data: PendingContractDepartmentsData,
  },] = useLazyGetPendingContractDepartmentsQuery();

  const [getInstrumentTypes, {
    isFetching: isInstrumentFetching,
    isSuccess: isInstrumentSuccess,
    data: instrumentTypeData
  }] = useLazyGetInstrumentTypeListQuery();

  const [getAllScopeTypes, {
    isFetching: isScopeTypeFetching,
    isSuccess: isScopeTypeFetched,
    data: scopeTypesData
  }] = useLazyGetScopeTypeListQuery();

  const [checkScopeSerialNumberExists] = useLazyCheckScopeSerialNumberExistsQuery();

  const [getScopeTypeDetailsById, {
    isFetching: isScopeTypeDetailsByidFetching,
    isSuccess: isScopeTypeDetailsByIdFetched,
    data: scopeTypeDetailsByIdData
  }] = useLazyGetScopeTypeDetailsByIdQuery();

  const [savePendingContractScopes, {
    isSuccess: isSavePendingContractScopesSuccess,
    data: SavePendingContractScopesData
  }] = useSavePendingContractScopesMutation();

  useEffect(() => {
    if (pendingContractId) {
      const request = {
        plPendingContractKey: pendingContractId
      }
      getAllClientsByPendingContractId(request);
      getInstrumentTypes();
      setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingContractId]);

  useEffect(() => {
    if (editRowData) {
      setIsEdit(true);
      getAllScopeTypes(editRowData?.sRigidOrFlexible);
      if (editRowData.sSerialNumber === 'TBD') {
        setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, false);
      }
      else {
        setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, true);
      }
      let formData = { ...addPendingContractConfigForm }
      formData.initialState = {
        ...formData.initialState,
        lClientKey: editRowData.lClientKey,
        lDepartmentKey: editRowData.lDepartmentKey,
        sInstrumentTypeKey: editRowData.sRigidOrFlexible,
        plScopeTypeKey: editRowData?.lScopeTypeKey,
        sSerialNumber: editRowData.sSerialNumber,
        lQuantity: editRowData.lQuantity,
        nUnitCost: editRowData.nUnitCost,
      };
      setAddPendingContractConfigForm(formData);
      setGridData([{
        id: editRowData.id,
        client: editRowData.lClientKey,
        department: editRowData.lDepartmentKey,
        model: editRowData.sRigidOrFlexible,
        serial: editRowData.sSerialNumber || '',
        plScopeTypeKey: { label: editRowData.sScopeTypeDesc, value: editRowData.lScopeTypeKey },
        quantity: editRowData.lQuantity || 0,
        unitCost: editRowData.nUnitCost || 0,
        totalCost: (editRowData.lQuantity || 0) * (editRowData.nUnitCost || 0),
      }])
    }
       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editRowData]);


  useEffect(() => {
    if (!isScopeTypeDetailsByidFetching && isScopeTypeDetailsByIdFetched && scopeTypeDetailsByIdData) {
      let formData = { ...addPendingContractConfigForm }
      formData.initialState = {
        ...formData.initialState,
        nUnitCost: scopeTypeDetailsByIdData?.nContractCost ? scopeTypeDetailsByIdData.nContractCost : "0"
      };
      setAddPendingContractConfigForm(formData);
    }
       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScopeTypeDetailsByidFetching, isScopeTypeDetailsByIdFetched, scopeTypeDetailsByIdData]);

  useEffect(() => {
    if (isSavePendingContractScopesSuccess && SavePendingContractScopesData) {
      ToastService.success(SavePendingContractScopesData.errorMessage);
      handleCloseModel();
      getPendingContractScopes(pendingContractId);
    }
       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSavePendingContractScopesSuccess, SavePendingContractScopesData,]);

  useEffect(() => {
    if (!isAllClientsByPendingContractIdFetching && isAllClientsByPendingContractIdFetched && allClientsByPendingContractIdData) {
      const updatedConfig = { ...addPendingContractConfigForm };
      mapDropdownOptions(updatedConfig, "specificationsSection", "lClientKey", allClientsByPendingContractIdData, "lClientKey", "sClientName1");

        getPendingContractDepartments({
          plPendingContractKey: pendingContractId,
          plClientKey: 0
        });
      setAddPendingContractConfigForm(updatedConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllClientsByPendingContractIdFetching, isAllClientsByPendingContractIdFetched, allClientsByPendingContractIdData]);

  useEffect(() => {
    if (!isPendingContractDepartmentsFetching && isPendingContractDepartmentsFetched && PendingContractDepartmentsData) {
      const updatedConfig = { ...addPendingContractConfigForm };
      mapDropdownOptions(updatedConfig, "specificationsSection", "lDepartmentKey", PendingContractDepartmentsData, "lDepartmentKey", "sDepartmentName");
      if (PendingContractDepartmentsData.length === 1) {

        updatedConfig.initialState = {
          ...updatedConfig.initialState,
          lDepartmentKey: {
            label: PendingContractDepartmentsData.sDepartmentName,
            value: PendingContractDepartmentsData.lDepartmentKey
          }
        };
      }
      setAddPendingContractConfigForm(updatedConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPendingContractDepartmentsFetching, isPendingContractDepartmentsFetched, PendingContractDepartmentsData]);

  useEffect(() => {
    if (!isInstrumentFetching && isInstrumentSuccess && instrumentTypeData) {

      const updatedConfig = { ...addPendingContractConfigForm };
      mapDropdownOptions(updatedConfig, 'specificationsSection', 'sInstrumentTypeKey', instrumentTypeData, 'sInstrumentTypeKey', 'sInstrumentType')
      setAddPendingContractConfigForm(updatedConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInstrumentFetching, isInstrumentSuccess, instrumentTypeData])

  useEffect(() => {
    if (!isScopeTypeFetching && isScopeTypeFetched && scopeTypesData) {
      const updatedConfig = { ...addPendingContractConfigForm };
      mapDropdownOptions(updatedConfig, 'specificationsSection', 'plScopeTypeKey', scopeTypesData, 'lScopeTypeKey', 'sScopeTypeDesc')
      setAddPendingContractConfigForm(updatedConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScopeTypeFetching, isScopeTypeFetched, scopeTypesData]);

  const handleFieldChange = (dataField, updatedFormData) => {
    let updatedState = { ...updatedFormData };

    if (dataField === "lClientKey") {
      const selectedClient =
        updatedFormData.lClientKey?.value ?? updatedFormData.lClientKey;
      getPendingContractDepartments({
        plPendingContractKey: pendingContractId,
        plClientKey: selectedClient
      });
      updatedState = {
        ...updatedState,
        lDepartmentKey: null
      };
      setAddPendingContractConfigForm((prev) => ({
        ...prev,
        initialState: updatedState,
      }));
      return;
    }

    if (dataField === "sInstrumentTypeKey") {
      const selectedInstrumentType =
        updatedFormData.sInstrumentTypeKey?.value ??
        updatedFormData.sInstrumentTypeKey;

      getAllScopeTypes(selectedInstrumentType);

      const selectedClientKey =
        updatedFormData.lClientKey?.value ?? updatedFormData.lClientKey;
      const clientRecord = allClientsByPendingContractIdData?.find(
        (x) => x.lClientKey === selectedClientKey
      );

      updatedState = {
        ...updatedState,
        plScopeTypeKey: clientRecord?.lScopeTypeKey ?? null,
        sSerialNumber: 'TBD',
        lQuantity: 1,
        nUnitCost: 0.00,
      };
      setAddPendingContractConfigForm((prev) => ({
        ...prev,
        initialState: updatedState,
      }));

      return;
    }
    if (dataField === "plScopeTypeKey") {
      const selectedScopeTypeKey =
        updatedFormData.plScopeTypeKey?.value ??
        updatedFormData.plScopeTypeKey;
      getScopeTypeDetailsById(selectedScopeTypeKey);
    }
    setAddPendingContractConfigForm((prev) => ({
      ...prev,
      initialState: updatedState,
    }));
  };

  const handleFiledBlure = (dataField, updatedFormData) => {
    if (dataField === 'sSerialNumber') {
      if (updatedFormData.sSerialNumber !== 'TBD') {
        setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, true);
        let formData = { ...AddPendingContractConfig }
        formData.initialState = {
          ...updatedFormData,
          lQuantity: 1
        };
        setAddPendingContractConfigForm(formData);
      }
      else {
        setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, false);
      }
    }
  }

  const handleAddClick = async () => {
    const formData = SpecificationsRef?.current?.getFormData();
    if (!formData) return;
    if (formData.sSerialNumber.trim() !== 'TBD') {
      let exist = await checkScopeSerialNumberExists(formData?.sSerialNumber);
      if (exist?.data?.serialNumberExists === true) {
        confirm(`Serial ${formData?.sSerialNumber} Number already exists`, " Do you wish to add a new scope with this number?", "Yes", "No")
          .then((confirmed) => {
            if (confirmed) {
              setGridData((prevData) => [
                ...prevData,
                {
                  id: gridData.length + 1,
                  client: formData?.lClientKey || null,
                  department: formData?.lDepartmentKey || null,
                  model: formData?.sInstrumentTypeKey,
                  serial: formData?.sSerialNumber || '',
                  plScopeTypeKey: formData?.plScopeTypeKey,
                  quantity: formData?.lQuantity || 0,
                  unitCost: formData?.nUnitCost || 0,
                  totalCost: (formData?.lQuantity || 0) * (formData?.nUnitCost || 0),
                }
              ]
              );
            }
            else {
              return;
            }
          });
      }
      else {
        setGridData((prevData) => [
          ...prevData,
          {
            id: gridData.length + 1,
            client: formData?.lClientKey,
            department: formData?.lDepartmentKey || null,
            model: formData?.sInstrumentTypeKey || null,
            serial: formData?.sSerialNumber || '',
            plScopeTypeKey: formData?.plScopeTypeKey,
            quantity: formData?.lQuantity || 0,
            unitCost: formData?.nUnitCost || 0,
            totalCost: (formData?.lQuantity || 0) * (formData?.nUnitCost || 0),
          }
        ]);
      }
    }
    else {
      setGridData((prevData) => [
        ...prevData,
        {
          id: gridData.length + 1,
          client: formData?.lClientKey || null,
          department: formData?.lDepartmentKey || null,
          model: formData?.sInstrumentTypeKey,
          serial: formData?.sSerialNumber || '',
          plScopeTypeKey: formData?.plScopeTypeKey,
          quantity: formData?.lQuantity || 0,
          unitCost: formData?.nUnitCost || 0,
          totalCost: (formData?.lQuantity || 0) * (formData?.nUnitCost || 0),
        }
      ]);
    }
  };

  const handleEditRow = (rowData) => {
    setIsEdit(true);
    getAllScopeTypes(rowData?.model?.value ?? rowData?.model);
    if (rowData.serial === 'TBD') {
      setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, false);
    }
    else {
      setFieldSetting(AddPendingContractConfig, 'lQuantity', FieldSettingType.DISABLED, true);
    }
    let formData = { ...addPendingContractConfigForm }
    formData.initialState = {
      ...formData.initialState,
      lClientKey: rowData.client,
      lDepartmentKey: rowData.department,
      sInstrumentTypeKey: rowData.model,
      plScopeTypeKey: rowData?.plScopeTypeKey,
      sSerialNumber: rowData.serial,
      lQuantity: rowData.quantity,
      nUnitCost: rowData.unitCost,
    };
    setAddPendingContractConfigForm(formData);
  };

  const handleDeleteRow = (rowData) => {
    let removeId = rowData.id;
    setGridData((prevData) => prevData.filter((item) => item.id !== removeId));
  };

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: "Edit",
        command: () => handleEditRow(row),
      },
      {
        label: "Remove",
        command: () => handleDeleteRow(row),
      }
    ];
  }

  const handleUpdateClick = () => {
    const formData = SpecificationsRef?.current?.getFormData();
    if (!formData) return;
    const scopeOptions = scopeTypesData?.map(x => ({
      value: x.lScopeTypeKey,
      label: x.sScopeTypeDesc ?? x.lScopeTypeKey.toString()
    }));
    let scope = getSelectedDropdownObject(formData?.plScopeTypeKey, scopeOptions);
    setGridData((prevData) => prevData.map((item) => {
      if (item.id === gridData.length || editRowData?.lPendingContractScopeKey) {
        return {
          ...item,
          client: formData?.lClientKey,
          department: formData?.lDepartmentKey,
          model: formData?.sInstrumentTypeKey,
          serial: formData?.sSerialNumber || '',
          plScopeTypeKey: editRowData ? scope : formData?.plScopeTypeKey,
          quantity: formData?.lQuantity || 0,
          unitCost: formData?.nUnitCost || 0,
          totalCost: (formData?.lQuantity || 0) * (formData?.nUnitCost || 0),
        };
      }
      return item;
    }));
  };

  const handleSaveClick = () => {
    const filteredGridData = gridData.filter(
      (item) => item && Object.keys(item).length > 0
    );
    if (filteredGridData.length > 0) {
      const payload = filteredGridData.map((item) => ({
        plPendingContractScopeKey: typeof item?.id === "undefined" ? editRowData?.lPendingContractScopeKey : 0,
        plPendingContractKey: pendingContractId,
        plScopeTypeKey: item?.plScopeTypeKey?.value ?? item?.plScopeTypeKey,
        psSerialNumber: item?.serial,
        plQuantity: item?.quantity,
        pnUnitCost: item?.unitCost,
        plDepartmentKey: item?.department?.value || null,
        plClientKey: item?.client?.value || null,
        plScopeKey: item?.plScopeKey || null,
      }));
      savePendingContractScopes(payload);
    }
  };

  const handleCloseModel = () => {
    onClose();
    resetForm();
  };

  const resetForm = () => {
    let formData = { ...AddPendingContractConfig }
    formData.initialState = {};
    setAddPendingContractConfigForm(formData);
  };


  return (
    <>
      <div className="row">
        <FormCreator
          ref={SpecificationsRef}
          config={addPendingContractConfigForm}
          onColumnChange={handleFieldChange}
          onFieldBlure={handleFiledBlure}
        />
        <div className="col-12 d-flex justify-content-end button-submit">
          {
            !isEdit && (<>
              <Buttons
                buttonText="Add"
                buttonTypeClassName="btn blue-btn w-full"
                onClick={handleAddClick}
              // isLoading={isClientAdding}
              />
            </>)
          }
          {
            isEdit && (<>
              <Buttons
                buttonText="Update"
                buttonTypeClassName="btn blue-btn w-full"
                onClick={handleUpdateClick}
              // isLoading={isClientAdding}
              />
              <Buttons
                buttonText="Cancel"
                buttonTypeClassName="btn secondary-btn ml-4"
                onClick={() => setIsEdit(false)}
              // isLoading={isClientAdding}
              />
            </>)
          }

        </div>
        <div className="col-12 mt-3">
          <MolGrid
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            ctxMenuItems={getCtxMenuItems}
          >
            <Column
              field="plScopeTypeKey"
              header="Model"
              grouping
              sortable
              style={{ width: "35%" }}
              body={(row) => row.plScopeTypeKey?.label}
            />
            <Column
              field="serial"
              header="Serial#"
              grouping
              sortable
              style={{ width: "20%" }}
            />
            <Column
              field="quantity"
              header="Quantity"
              grouping
              sortable
              style={{ width: "15%" }}
            />
            <Column
              field="unitCost"
              header="Unit Cost"
              grouping
              sortable
              style={{ width: "15%" }}
            />
            <Column
              field="totalCost"
              header="Total Cost"
              grouping
              sortable
              style={{ width: "15%" }}
            />
          </MolGrid>
        </div>
        <div className="col-12 mt-3 d-flex justify-content-center button-submit">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="btn blue-btn w-full"
            onClick={handleSaveClick}
          // isLoading={isClientAdding}
          />
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="btn secondary-btn ml-4"
            onClick={handleCloseModel}
          // isLoading={isClientAdding}
          />
        </div>
      </div>
    </>
  );
};

export default AddPendingContractScopes;
